module.exports = __webpack_public_path__ + "static/media/pic3.46bce35e.jpeg";